import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, CircularProgress } from '@mui/material';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
// leaflet-heatmap plugin
import 'leaflet.heat';
import { getUsersGeoLocations } from '../api/admin';

const HeatmapLayer = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    // Remove any existing heat layer
    map.eachLayer(layer => {
      if (layer.options && layer.options.pane === 'overlayPane' && layer._latlngs) {
        map.removeLayer(layer);
      }
    });
    // Add heat layer
    const heat = window.L.heatLayer(points, { radius: 25, blur: 18, maxZoom: 6 });
    heat.addTo(map);
    return () => { map.removeLayer(heat); };
  }, [points, map]);
  return null;
};

const AdminGeoHeatMap = () => {
  const [geoData, setGeoData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUsersGeoLocations()
      .then(data => {
        // console.log('Geo heatmap data:', data);
        setGeoData(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const points = geoData
    .filter(g => g.latitude && g.longitude)
    .map(g => [g.latitude, g.longitude]);

  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        User Sessions World Heatmap
      </Typography>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ height: 500, width: '100%' }}>
          <MapContainer center={[20, 0]} zoom={2} style={{ height: '100%', width: '100%' }} scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <HeatmapLayer points={points} />
          </MapContainer>
        </Box>
      )}
    </Paper>
  );
};

export default AdminGeoHeatMap;
